import { render, staticRenderFns } from "./CruiseListViewTableTr.vue?vue&type=template&id=10510fd4"
import script from "./CruiseListViewTableTr.vue?vue&type=script&lang=js"
export * from "./CruiseListViewTableTr.vue?vue&type=script&lang=js"
import style0 from "./CruiseListViewTableTr.vue?vue&type=style&index=0&id=10510fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports